import { createAction } from 'redux-act';

import MergedTable from '../../../models/interfaces/layout/MergedTable';
import { AnyReservation, ReservationSeating, SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import ReservationAcceptState from '../../../models/interfaces/reservation/ReservationAcceptState';
import ReservationRejectReason from '../../../models/interfaces/reservation/ReservationRejectReason';
import TimestampPayload from '../TimestampPayload';
import ReservationPayload from './ReservationPayload';

export interface ResolveReservationPayload extends ReservationPayload {
  pendingReservation: AnyReservation;
  seating?: ReservationSeating;
  mergedTable?: MergedTable;
}
export const resolveReservation = createAction<ResolveReservationPayload>('RESOLVE_RESERVATION');

export interface ReservationResolvedPayload extends TimestampPayload, ReservationPayload {
  reservation: SeatedReservation;
  createdMergedTable: MergedTable | null;
  acceptState: ReservationAcceptState | undefined;
}
export const reservationResolved = createAction<ReservationResolvedPayload>('RESERVATION_RESOLVED');

export interface ReservationResolveFailedPayload extends TimestampPayload, ReservationPayload {
  rejectReason: ReservationRejectReason | undefined;
}
export const reservationResolveFailed = createAction<ReservationResolveFailedPayload>('RESERVATION_RESOLVE_FAILED');
